<template>
  <div>
    <jd-dialog title="选择优惠券" :visible.sync="dialogPrize" :width="(libaoItem.name == '东券' || libaoItem.name == '京券') ? '1420px': '550px'" @close="dialogClose" :isShowSure="false" :isShowCancel="false">
      <div v-if="libaoItem.name == '东券' || libaoItem.name == '京券'">
           <jd-form
              ref="jdForm"
              :form-info="formInfo"
              @search="search"
            />
          <!-- <input-form
            ref="inputForms"
            :inputData="inputDataTwo"
            :btnPosition2="true"
            @toParentVal="searchContentTwo"
          ></input-form> -->
          <div style="margin: 16px 0px">
            <jd-button v-if="venderType" @click="handleAddCoupon2">添加发放型外部券</jd-button>
            <jd-button v-else  @click="handleAddCoupon" >创建发放型优惠券</jd-button>
          </div>
          <div class="coupon-tip-wrap">
            <jd-tip>
              <p>因官方接口限制，FCS店铺不支持优惠券奖品，请勿使用优惠券</p>
            </jd-tip>
          </div>
          <div class="new-table-box">
            <jd-table
              :tableData="externalTable"
              :loading="tableLoading"
              :tableInfo="tableInfo"
              :pageInfo="{
                pageSize: formListTwo.size,
                pageNum: formListTwo.current,
                total: totalNumTwo,
              }"
              style="margin-top: 12px;"
              @handlePage="handlePage"
            >
              <template #couponKind="scope">
                <span v-if="scope.row.couponKind == 0">全品类东券,</span>
                <span v-if="scope.row.couponKind == 1">限品类京券,</span>
                <span v-if="scope.row.couponKind == 2">店铺东券,</span>
                <span v-if="scope.row.couponKind == 3">限商品东券,</span>
                满{{ scope.row.quota }}减{{ scope.row.discount }}元
              </template>
              <template #takeBeginTime="scope">
                <span>起:{{ scope.row.takeBeginTime }}</span
                ><br />
                <span>止:{{ scope.row.takeEndTime }}</span>
              </template>
              <template #status="scope">
                <span v-if="scope.row.status == 1">未开始</span>
                <span v-if="scope.row.status == 2">进行中</span>
                <span v-if="scope.row.status == 3">已结束</span>
              </template>
              <template #handle="scope">
                <jd-button type="blueText"
                :disabled="selectedCouponId == scope.row.assetsId"
                  @click="
                    chooseTab(scope.row);
                  "> {{ selectedCouponId == scope.row.assetsId ? '已选择' : '选择' }}</jd-button>
                <!-- <el-button
                  style="width: 50px;margin-left: -10px;color: #fe4d45;"
                  class="Notetake"
                  type="text"
                  @click="
                    chooseTab(scope.row);
                    dialogVisibleFrom = false;
                  "
                >
                  选择
                </el-button> -->
              </template>
            </jd-table>
            <!-- <el-table
              v-loading="tableLoading"
              :data="externalTable"
              style="width: 100%"
              :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
              :cell-style="{ 'text-align': 'left' }"
            >
              <el-table-column prop="name" label="优惠券名称"> </el-table-column>
              <el-table-column prop="name" label="优惠券信息" width="150"> 
                <template slot-scope="scope">
                  <span v-if="scope.row.couponKind == 0">全品类东券,</span>
                  <span v-if="scope.row.couponKind == 1">限品类京券,</span>
                  <span v-if="scope.row.couponKind == 2">店铺东券,</span>
                  <span v-if="scope.row.couponKind == 3">限商品东券,</span>
                  满{{ scope.row.quota }}减{{ scope.row.discount }}元
                </template>
              </el-table-column>
              <el-table-column :prop="venderType?'putkey':'couponIdOrPutKey'" label="优惠券id/key" width="100"> </el-table-column>

              <el-table-column prop="createTime" label="创建时间" width="180"> </el-table-column>
              <el-table-column label="领取时间" width="180">
                <template slot-scope="scope">
                  <span>起:{{ scope.row.takeBeginTime }}</span
                  ><br />
                  <span>止:{{ scope.row.takeEndTime }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="balanceNum" label="剩余数量" width="130"> </el-table-column>
              <el-table-column prop="status" label="奖品状态" width="130"> 
            <template slot-scope="scope">
              <span v-if="scope.row.status == 1">未开始</span>
              <span v-if="scope.row.status == 2">进行中</span>
              <span v-if="scope.row.status == 3">已结束</span>
            </template>
          </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">

                  <el-button
                    style="width: 50px;margin-left: -10px;color: #fe4d45;"
                    class="Notetake"
                    type="text"
                    @click="
                      chooseTab(scope.row);
                      dialogVisibleFrom = false;
                    "
                  >
                    选择
                  </el-button>
                </template>
              </el-table-column>
            </el-table> -->
          </div>
          <div class="flexc mt16">
            <span class="label-style">去使用链接：</span>
            <div>
              <el-radio-group v-model="prizeGoShop.goShopSetting"  @change="onShopSetChange">
                <el-radio :label="0">进入店铺首页</el-radio>
                <el-radio :label="1">跳转指定小程序</el-radio>
                <el-radio :label="2">进入指定链接</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div v-if="prizeGoShop.goShopSetting == 1" class="mt16">
            <div class="flex-x-start">
              <div class="label-style">
                <span class="req-style">*</span> 
                小程序appId：
              </div>
              <el-input
                type="textarea"
                placeholder="请输入小程序appId"
                style="width: 425px; margin-left: 8px"
                show-word-limit
                v-model="prizeGoShop.goShopAppId"
                :maxlength="1000"
              ></el-input>
            </div>
            <div class="flex-x-start mt16">
              <span class="label-style">页面路径path：</span>
              <el-input
                type="textarea"
                placeholder="请输入小程序页面路径path"
                style="width: 425px; margin-left: 8px"
                show-word-limit
                v-model="prizeGoShop.goShopUrl"
                :maxlength="1000"
              ></el-input>
            </div>
            <div class="link-tip">
              注意：path若不写，则默认进入小程序主页。
            </div>
          </div>
          <div
            v-if="prizeGoShop.goShopSetting == 2"
            class="flex-x-start mt16"
          >
            <div class="label-style">
              <span class="req-style">*</span>
              指定链接：
            </div>
            <el-input
              type="textarea"
              placeholder="请输入指定链接"
              style="width: 425px; margin-left: 8px"
              show-word-limit
              v-model="prizeGoShop.goShopUrl"
              :maxlength="1000"
            ></el-input>
          </div>
          <div class="link-tip" v-if="prizeGoShop.goShopSetting == 2">
            注意：仅可填写京东域内的
            H5页面地址，不可设置外链。参考链接：https://m.jd.com/。
          </div>
          <div class="coupon-btn">
            <jd-button
              type="blue"
              :disabled="!couponObj.id||((prizeGoShop.goShopSetting == 1&&!prizeGoShop.goShopAppId)||(prizeGoShop.goShopSetting == 2&&!prizeGoShop.goShopUrl))"
              @click="handleSubmitCoupon"
              >确定</jd-button
            >
          </div>
          <!-- <div class="new-pagination-page" style="margin-top: 20px">
            <el-pagination
              style="text-align: right;"
              @size-change="handleSizeChangeTwo"
              background
              @current-change="handleCurrentChangeTwo"
              :page-sizes="[10, 20, 30, 50, 100, 500]"
              :page-size="10"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalNumTwo"
              :current-page="1"
            ></el-pagination>
          </div> -->
        </div>
      <template v-else>
        <div v-if="venderType">
          <jd-tip color="yello" >
            <div>
              <span v-if="libaoItem.name == '京豆'">注意：为保证活动奖品正常发放，建议选择发豆规则与奖品发放规则一致的计划。</span>
              <!-- <span v-if="libaoItem.name == '店铺积分'">注：店铺积分：发放积分需要加入京东会员体系，并开通积分功能</span> -->
            </div>
          </jd-tip>
        </div>
        <div v-if="!venderType">
          <jd-tip color="yello" >
            <div>
              <span v-if="libaoItem.name == '京豆'">注意：为保证活动奖品正常发放，建议选择发豆规则与奖品发放规则一致的计划。</span>
              <span v-if="libaoItem.name == '店铺积分'">注：店铺积分：发放积分需要加入京东会员体系，并开通积分功能</span>
            </div>
          </jd-tip>
        </div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" style="margin-top:20px">
          <!--京豆  -->
          <template v-if="libaoItem.name == '京豆'">
            <el-form-item label="选择京豆计划:" v-if="venderType">
              <!-- <el-input v-model="ruleForm.activityName" style="width: 200px"></el-input> -->
              <el-select v-model="ruleForm.activityName" placeholder="请选择" @change="planChange" style="width: 200px">
                <el-option v-for="(item, index) in selectList" :key="index" :label="item.label" :value="item"></el-option>
              </el-select>
              <jd-button type="blueText" style="margin-left: 8px" @click="sxJingdou"> 刷新</jd-button>
              <jd-button type="break" style="margin-left: 8px" @click="jumpJingduo">创建京豆计划</jd-button>
              <div v-show="activeSendtimes">
                <span>京豆计划的发豆次数，最多</span>
                <span style="color:#fe4d45"> {{ activeSendtimes }} </span>次
              </div>
            </el-form-item>

            <el-form-item label="单份奖励个数:">
              <el-input v-model="ruleForm.singleAmount" @input.native="checkputn" placeholder="请输入" style="width: 140px"></el-input>
              个京豆（每人每次发送的京豆个数）
            </el-form-item>
          </template>
          <!-- 店铺积分  -->
          <el-form-item label-width="92px" label="积分数量:" v-if="libaoItem.name == '店铺积分'">
            <el-input v-model="ruleForm.point" @input.native="checkputn" placeholder="请输入" style="width: 200px"></el-input>
          </el-form-item>
        </el-form>
        <jd-button type="break" @click="handleConfirm" style="margin-left: 8px">
          {{ libaoItem.name == "店铺积分" ? "选择店铺积分奖品" : "选择京豆发放" }}
        </jd-button>
      </template>
    </jd-dialog>
    <add-coupon :isSuperFission="true" :isShow="addCouponIsShow" @close="addCouponIsShow = false" @funcMes="addStatus"></add-coupon>
    <add-coupon2 :isShow="addCouponIsShow2" @close="addCouponIsShow2 = false" @funcMes="addStatus2"></add-coupon2>
  </div>
</template>

<script>
import inputForm from "@/components/jhk/inputForm";
import SelectGoods from "@/components/selectGoodsMonitor2.vue";
import { mapState } from "vuex";
import { couponList, jingdouList, allAccountList, redPacketList, judgingActivation } from "@/api/jhk/integralCenter/prizeCenter.js";
import { querySellerCouponWriteList, querySellerCouponExternalList,createSellerCouponWrite } from "@/api/jhk/integralCenter/couponWriteController";
import addCoupon from './add_coupon1.vue'
import addCoupon2 from './add_coupon2.vue'
export default {
  name: "selectPrize",
  components: {
    SelectGoods,
    addCoupon,
    addCoupon2,
    inputForm,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    inShopShow: {
      type: Boolean,
      default: true,
    },
    outShopShow: {
      type: Boolean,
      default: false,
    },
    libaoItem: {
      type: Object,
      default() {
        return {
          name: "东券",
          num: 0,
        };
      },
    },
    //typeDefault可不传 默认京券 免费领取 不公开
    typeDefault: {
      type: Object,
      default() {
        return {
          grantType: 3, // 发放类型  传对应的id值
          display: 1, // 是否公开  传对应的id值
          type: 0, // 不禁用  传对应的id值
          noDisabled: [3], // 不禁用  传对应的id值  可不传（默认全部禁用）
        };
      },
    },
    // num != 2 JingdouCount中的prizeCount必传 计算填的京豆总数是否大于京豆总数
    JingdouCount: {
      type: Object,
      default() {
        return {
          prizeCount: 0,
        };
      },
    },
    num: {
      default: 2,
    },
    echoDate: {
      type:Object,
      default: null
    }
  },
  computed: {
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    tableInfo() {
      let arr = [
        {
          label:'优惠券名称',
          prop:'name'
        },
        {
          label:'优惠券信息',
          prop:'couponKind',
          slot:'couponKind',
          width:'150'
        },
        {
          label:'优惠券id/key',
          prop:this.venderType?'putkey':'couponIdOrPutKey',
          width:'120'
        },
        {
          label:'创建时间',
          prop:'createTime',
          width:'180'
        },
        {
          label:'领取时间',
          prop:'takeBeginTime',
          slot:'takeBeginTime',
          width:'180'
        },
        {
          label: "可用优惠券数量",
          prop: "canUseBalanceNum",
          width: 120,
        },
        {
          label:'剩余数量',
          prop:'balanceNum',
          width:'130',
          align:'right'
        },
        {
          label:'奖品状态',
          prop:'status',
          width:'130',
          slot:'status'
        },
        {
          label:'操作',
          prop:'handle',
          slot:'handle',
        },
      ]
      return arr
    }
  },
  watch: {
    async value(val) {
      // this.quireList();
      if (val) {
        if (this.libaoItem && this.libaoItem.num === 0) {
     
          // 配置优惠券查询走这里 可默认
          this.formList.type = String(this.typeDefault.type);
          this.formList.display = String(this.typeDefault.display);
          this.formList.grantType = String(this.typeDefault.grantType);
          if (this.typeDefault && this.typeDefault.noDisabled) {
            this.labelList.forEach((item) => {
              this.typeDefault.noDisabled.forEach((i) => {
                if (item.value == i) {
                  item.disabled = false;
                } else {
                  item.disabled = true;
                }
              });
            });
          }
          if (this.outShopShow && !this.inShopShow) {
            this.activeName = "second";
            this.querySellerCouponExternal();
          }
          this.quireList();
          if(this.echoDate) {
            this.selectedCouponId = this.echoDate.assetsId || "";
            this.couponObj = {
              ...this.echoDate,
              discount: this.echoDate.price,
              name: this.echoDate.title,
            };
            this.couponObj.couponId = this.echoDate.assetsId;
            this.couponObj.id = this.echoDate.assetsId;
            delete this.couponObj.prizeGoShop;
            this.prizeGoShop = this.echoDate.prizeGoShop ? JSON.parse(this.echoDate.prizeGoShop) : {
              goShopSetting: 0,
              goShopAppId: "",
              goShopUrl: "",
            }
          } else {
            this.prizeGoShop = {
              goShopSetting: 0,
              goShopAppId: "",
              goShopUrl: "",
            }
          }

        } else {
          // 店铺礼包另外  不动 已些死
          if (this.libaoItem.prizeType == "4") {
            this.ruleForm.singleAmount = this.libaoItem.singleAmount;
            if (this.libaoItem.assetsId) {
              this.formLitJD.id = this.libaoItem.assetsId;
              const res = await jingdouList(this.formLitJD);
              this.selectList = res.data.records.map((item) => ({
                label: item.planName,
                value: item.id,
                sendTimes: item.sendTimes,
              }));
              this.planList.jingdou = res.data.records;
              this.ruleForm.activityName.label = res.data.records[0].planName;
              this.ruleForm.activityName.value = res.data.records[0].id;
              this.ruleForm.activityName.sendTimes = res.data.records[0].sendTimes;
            } else {
              this.getJingdouList();
            }
            // this.getJingdouList();
          }
          if (this.libaoItem.prizeType == "6") {
            this.ruleForm.point = this.libaoItem.singleAmount;
          }
          if (this.libaoItem.prizeType == "0" || this.libaoItem.prizeType == "1") {
            this.formList.type = this.libaoItem.prizeType;
            this.formList.grantType = "5";
            this.formList.display = "1";
            this.typeDefault.type = "0";
            this.typeDefault.display = "1";
            this.typeDefault.grantType = "5";
            this.labelList[4].disabled = false;
            this.quireList();
          }
        }
      }
      this.dialogPrize = val;
    },
  },
  created() {},
  mounted() {
    // this.$nextTick(() => {
    //   this.$refs.inputForms.formSearch();
    // });
  },
  data() {
    return {
      // 优惠券去使用链接配置
      selectedCouponId: '',
      couponObj: {},
      prizeGoShop: {
        goShopSetting: 0,
        goShopAppId: "",
        goShopUrl: "",
      },
      echoDate: {},
      addCouponIsShow: false,
      formInfo:[
        {
          label: "优惠券名称：",
          prop: "name",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "优惠券id/key：",
          prop: "couponIdOrPutKey",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "奖品状态：",
          prop: "status",
          type: "Select",
          options: [
            { label: "全部", value: null },
            { label: "未开始", value: 1 },
            { label: "进行中", value: 2 },
            { label: "已结束", value: 3 },
          ],
        },
        {
          label: "优惠券使用范围：",
          prop: "couponKind",
          type: "Select",
          options: [
            { label: "全部", value: null },
            { label: "全店", value: 2 },
            { label: "商品", value: 3 },
            { label: "全品类", value: 0 },
            { label: "限品类", value: 1 },
          ],
        },
        {
          label: "活动时间：",
          prop: "dateRange",
          type: "DateRange",
          dateType: "datetime",
          startTime:this.getDateStr(-30) + " 00:00:00",
          endTime:this.getDateStr(0) + " 23:59:59",
          startKey: "beginTime",
          endKey: "endTime",
          defalutLimit:true
        },
      ],
      inputDataTwo: [
        {
          name: "优惠券名称:",
          val: "name",
          placeholder: "请输入",
        },
        {
          name: "优惠券id/key:",
          val: "couponIdOrPutKey",
          placeholder: "请输入",
        },
        {
          name: "奖品状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: null },
            { label: "未开始", id: 1 },
            { label: "进行中", id: 2 },
            { label: "已结束", id: 3 },
          ],
        },
        {
          name: "优惠券使用范围:",
          val: "couponKind",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: null },
            { label: "全店", id: 2 },
            { label: "商品", id: 3 },
            { label: "全品类", id: 0 },
            { label: "限品类", id: 1 },
          ],
        },
        {
          name: "创建时间:",
          myDate: true,
          val: ["beginTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault: true,
        },
      ],
      awardSettingsLsit: [
        {
          prizeType: 1,
          price: null,
          title: "",
          singleAmount: null,
          totalAmount: "",
          inviteNum: null,
          takeEndTime: null,
          takeBeginTime: null,
          isMain: 1,
          quota: null,
        },
      ],
      FissionVoucherList: [],
      addCouponIsShow2: false,

      isPointsEnabled: false,
      labelList: [
        { label: "促销绑定", value: "1", disabled: true },
        { label: "推送", value: "2", disabled: true },
        { label: "免费领取", value: "3", disabled: true },
        { label: "京豆换券", value: "4", disabled: true },
        { label: "互动平台", value: "5", disabled: true },
      ],
      dialogPrize: false,
      selectList: [],
      ruleForm: {
        activityName: {},
        singleAmount: "",
        point: "",
      },
      jingdouData: {},
      rules: {},
      activeName: "first",
      internalTable: [],
      externalTable: [],
      totalNum: 0,
      totalNumTwo: 0,
      formList: {
        current: 1,
        size: 10,
        isTake: 1,
        type: "",
        display: "",
        grantType: "",
      },
      formListTwo: {
        current: 1,
        size: 10,
        isTake: 1,
        issueType: 1,
      },
      // 京豆
      formLitJD: {
        current: 1,
        size: 100,
        isFilterUsed: true,
        status: 2,
      },
      activeSendtimes: "",
      planList: {
        jingdou: {},
      },
      tableLoading: false,
    };
  },
  methods: {
    handleSubmitCoupon() {
      // 跳转链接校验
      if (this.prizeGoShop.goShopSetting == 1 && !this.prizeGoShop.goShopAppId) {
        this.$message.warning("请输入小程序appId");
        return;
      }
      if (this.prizeGoShop.goShopSetting == 2) {
        if (!this.prizeGoShop.goShopUrl) {
          this.$message.warning("请输入指定链接");
          return;
        } else if (
          !this.prizeGoShop.goShopUrl.startsWith("https://") ||
          !this.prizeGoShop.goShopUrl.includes("jd.com")
        ) {
          this.$message.warning(
            "输入的内容非链接或为接口无法支持的链接，请重新设置"
          );
          return;
        }
      }
      this.$emit("closePrize", true, {...this.couponObj,prizeGoShop: JSON.stringify(this.prizeGoShop)});
    },
    onShopSetChange(value) {
      this.prizeGoShop.goShopAppId = "";
      this.prizeGoShop.goShopUrl = "";
    },
    handleSizeChange2(val) {
      this.formListTwo.size = val;
      this.quireList();
    },
    handleCurrentChange2(val) {
      this.formListTwo.current = val;
      this.quireList();
    },
    addStatus(val) {
      let obj = val
      createSellerCouponWrite(obj)
        .then((res) => {
          if (res && res.code == 1) {
            this.$message.success(res.message);
            // this.$refs.inputForms.formSearch();
            this.$refs.jdForm.handleSearch();
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((res) => {});
      // this.awardSettingsLsit[0].assetsId = data
      return
      if (this.isMain == 1) {
        this.awardSettingsLsit[0].innerCouponDto = val;
        this.awardSettingsLsit[0].quota = val.quota;
        this.awardSettingsLsit[0].beginTime = val.takeBeginTime;
        this.awardSettingsLsit[0].endTime = val.takeEndTime;
        this.awardSettingsLsit[0].totalAmount = val.num;
        this.awardSettingsLsit[0].title = val.name;
        this.awardSettingsLsit[0].price = val.discount;
        this.awardSettingsLsit[0].couponType = val.bindType;
        this.awardSettingsLsit[0].singleAmount = 1;
      } else {
        // if (this.superSplitCoupon) {
        //   this.FissionVoucherList[0].innerCouponDto = val;
        //   this.FissionVoucherList[0].quota = val.quota;
        //   this.FissionVoucherList[0].beginTime = val.takeBeginTime;
        //   this.FissionVoucherList[0].endTime = val.takeEndTime;
        //   this.FissionVoucherList[0].totalAmount = val.num;
        //   this.FissionVoucherList[0].title = val.name;
        //   this.FissionVoucherList[0].price = val.discount;
        //   this.FissionVoucherList[0].couponType = val.type;
        // } else {
        this.FissionVoucherList[this.indexCoupon].quota = val.quota;
        this.FissionVoucherList[this.indexCoupon].beginTime = val.takeBeginTime;
        this.FissionVoucherList[this.indexCoupon].endTime = val.takeEndTime;
        this.FissionVoucherList[this.indexCoupon].totalAmount = val.num;
        this.FissionVoucherList[this.indexCoupon].title = val.name;
        this.FissionVoucherList[this.indexCoupon].price = val.discount;
        this.FissionVoucherList[this.indexCoupon].couponType = val.bindType;
        this.FissionVoucherList[this.indexCoupon].innerCouponDto = val;
        this.FissionVoucherList[this.indexCoupon].singleAmount = 1;

        console.log(this.FissionVoucherList, 111111);
        // }
      }
    },
    addStatus2() {
      // this.$refs.inputForms.formSearch();
       this.$refs.jdForm.handleSearch();
    },
    search(obj){
      for (const key in obj) {
        this.formListTwo[key] = obj[key];
      }
      this.formListTwo.current = 1;
      this.formListTwo.isTake = 1;
      this.querySellerCouponExternal();
    },
    searchContentTwo(val) {
      console.log(val);
      this.formListTwo = {
        current: '1',
        isTake: 1,
        ...val
      }
      // this.formListTwo.current = "1";
      // this.formListTwo.name = val.name;
      // this.formListTwo.discount = val.discount;
      // this.formListTwo.beginTime = val.beginTime;
      // this.formListTwo.endTime = val.endTime;
      // this.formListTwo.issueType = val.issueType;

      this.querySellerCouponExternal();
    },
    handleAddCoupon() {
      this.addCouponIsShow = true
      // this.echoDate = {}
    },
    handleAddCoupon2() {
      this.addCouponIsShow2 = true
      // this.echoDate2 = {}
    },
    handlelink() {
      window.open("https://member.shop.jd.com/index/newmemberlevel");
    },
    // 积分  京东发放
    handleConfirm() {
      // this.ruleForm.prizeType =
      let params = {
        ...this.ruleForm,
        prizeType: this.libaoItem.prizeType,
      };
      // if (this.libaoItem.prizeType == "4") {
      //   if (!this.ruleForm.activityName.value || !this.ruleForm.singleAmount) {
      //     return this.$message.warning("请填写完整");
      //   }
      // }
      if (this.libaoItem.prizeType == "6") {
        if (!this.ruleForm.point) {
          return this.$message.warning("请填写积分");
        }
      }
      let jingdouPlanList = null;
      let item = {};
      if (this.libaoItem.name == "京豆") {
        let line = this.JingdouCount;
        if(this.venderType){
          jingdouPlanList = this.planList.jingdou;
          item = jingdouPlanList.find((i) => {
          return i.id == this.jingdouData.couponId;
         });
        }
        if (item) {
          // if (
          //   line.prizeCount &&
          //   this.ruleForm.singleAmount &&
          //   Number(line.prizeCount) * Number(this.ruleForm.singleAmount) > Number(item.quantityTotal)
          // ) {
          //   this.$message.error("京豆发放数量不能大于该京豆预算额！");
          //   return;
          // }
          // if (this.ruleForm.singleAmount && Number(this.ruleForm.singleAmount) > Number(item.quantityTotal)) {
          //   this.$message.error("单份奖励个数不能大于该京豆预算额！");
          //   return;
          // }
          if (!this.ruleForm.singleAmount) {
            this.$message.error("请填写京豆单份奖励个数！");
            return;
          }
          // if (!line.prizeCount) {
          //   this.$message.error("京豆奖励需先填写奖品总份额！");
          //   return;
          // }
        }
      }
      // console.log(params, 555);
      this.$emit("closePrize", true, { ...params, quantityTotal: item.quantityTotal });
    },
    // 京东券
    chooseTab(item) {
      let params = item;
      // params.prizeType = this.libaoItem.prizeType;
      // params.title = item.name;
      // params.name = item.discount + "元优惠券";
      // params.id = item.assetsId
      // params.couponId = item.assetsId
      this.selectedCouponId = item.assetsId;
      const couponObj = {
        prizeType: this.libaoItem.prizeType,
        title: item.name,
        name: item.discount + "元优惠券",
        id: item.assetsId,
        couponId: item.assetsId,
      }
      this.couponObj = {...params,...couponObj}
      // this.$emit("closePrize", true, params);
    },
    sxJingdou() {
      this.formLitJD = {
        current: 1,
        size: 100,
        isFilterUsed: true,
        status: 2,
      };
      this.getJingdouList();
    },
    //查询京豆
    async getJingdouList() {
      const res = await jingdouList(this.formLitJD);
      let selectArr = res.data.records.map((item) => {
        return {
          label: item.planName,
          value: item.id,
          sendTimes: item.sendTimes,
        };
      });
      this.selectList = selectArr;
      this.planList.jingdou = res.data.records;
    },
    //获取优惠券
    quireList() {
      // this.formList.beginTime = this.nowTime;
      // this.querySellerCouponExternal()
      setTimeout(() => {
        // this.$refs.inputForms.formSearch();
         this.$refs.jdForm.handleSearch();
      }, 100);
      return
      this.tableLoading = true;
      couponList(this.formList).then((res) => {
        this.internalTable = res.data.records;
        this.internalTable.forEach((item) => {
          item.couponType = 1;
        });
        this.totalNum = Number(res.data.total);
        this.tableLoading = false;
      });
    },
    //查询外部优惠券信息
    querySellerCouponExternal() {
      this.tableLoading = true;
      console.log(111,this.formListTwo)
      querySellerCouponExternalList(this.formListTwo).then((res) => {
        this.externalTable = res.data.records;
        this.externalTable.forEach((item) => {
          // item.couponType = 2;
          item.couponId = Number(item.id);
        });
        this.totalNumTwo = Number(res.data.total);
        this.tableLoading = false;
      });
    },
    //切换
    handleTabClick(val) {
      // console.log(val);
      if (val.name == "second") {
        this.querySellerCouponExternal();
      }
    },
    // 创建内部优惠券
    jumpCreation() {
      window.open("https://passport.shop.jd.com/login/index.action?ReturnUrl=https%3A%2F%2Fpromo.shop.jd.com%2Fweb%2Fcoupon%2Fdetail%2Fshop%2F0%3F");
    },
    // 创建外部优惠券
    jumpSansCreation() {
      this.$router.push({
        name: "couponManagement",
        query: { to: 1 },
      });
    },
    // 创建京豆
    jumpJingduo() {
      let routeUrl = this.$router.resolve({
        path: "/integralCenter/prizeCenter/asset_management",
      });
      window.open(routeUrl.href, "_blank");
    },
    //  内部搜索
    handleSearch(val) {
      if (val == "1") {
        this.quireList();
      } else {
        // 外部
        this.querySellerCouponExternal();
      }
    },
    // 重置
    handleReset(val) {
      if (val == "1") {
        if (this.libaoItem.num === 0) {
          this.formList.type = String(this.typeDefault.type);
        }
        // this.formList.type = "";
        this.formList.grantType = String(this.typeDefault.grantType);
        this.formList.display = String(this.typeDefault.display);
        this.quireList();
      } else {
        this.formListTwo.name = "";
        this.formListTwo.discount = "";
        this.querySellerCouponExternal();
      }
    },
    planChange(val) {
      console.log(val);
      this.activeSendtimes = val.sendTimes;

      this.jingdouData = {
        couponId: val.value || "",
        // discount: this.jingduoForm.quota,
        discount: Number(val.count || ""),
        name: val.label || "",
        singleAmount: Number(val.count || ""),
      };
    },
    //输入框限制负数
    checkputn(e) {
      let filtered = e.target.value.replace(/^0|[^\d]/g, "");
      e.target.value = Number(filtered);
      // //下边写用户输入时需要的执行逻辑
      // if(this.ruleForm.inputprize!= filtered) {
      //     this.ruleForm.inputprize = filtered
      // }
      // 不能输入0，绑定的值如果小于1，那么输入框置空
      if (e.target.value < 1) {
        e.target.value = "";
      }
    },
    //分页事件
    handleSizeChange(val) {
      this.formList.size = val;
      this.quireList();
    },
    handleCurrentChange(val) {
      this.formList.current = val;
      this.quireList();
    },
    handlePage(val){
      this.formListTwo.current = val.pageNum;
      this.formListTwo.size = val.pageSize;
      this.querySellerCouponExternal()
    },
    handleSizeChangeTwo(val) {
      this.formListTwo.size = val;
      this.querySellerCouponExternal()
    },
    handleCurrentChangeTwo(val) {
      this.formListTwo.current = val;
      this.querySellerCouponExternal()
    },
    dialogClose() {
      this.$emit("closePrize", false);
    },
  },
};
</script>

<style scoped lang="scss">
.coupon-tip-wrap{
  margin-bottom: 10px;
}
.couponTypebox {
  background: green;
  width: 52px;
  color: #fff;
  margin: 0 auto;
  padding: 0px 4px;
  font-size: 12px;
}
.pointer {
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
}
.tip {
  width: 100%;
  // height: 44px;
  background: #fafafa;
  border-radius: 4px;
  padding: 15px 0 15px 12px;
  .desc {
    i {
      opacity: 0.7;
      color: #fe4d45;
    }
    color: #999;
  }
}
.enter {
  width: 104px;
  height: 32px;
  padding: 0 10px;
  background: #fe4d45;
  text-align: center;
  line-height: 32px;
  border-radius: 4px;
  margin-top: 26px;
  color: #ffffff;
  margin-left: 20px;
}
.shuaxin {
  display: inline-block;
  line-height: 32px;
  position: relative;
  padding-left: 22px;
  margin-left: 10px;
  &::before {
    width: 20px;
    height: 20px;
    background: url("https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/shuaxin.png");
    position: absolute;
    left: 0px;
    content: "";
    top: 5px;
  }
}
.chuangjian {
  margin-left: 10px;
  display: inline-block;
  width: 104px;
  height: 32px;
  background: #fe4d45;
  border: 1px solid #fe4d45;
  line-height: 32px;
  color: #fff;
  text-align: center;
  border-radius: 4px;
}
.search {
  color: #fff;
  border: 1px solid #fe4d45;
  background-color: #fe4d45;
  &:hover {
    opacity: 0.8;
  }
}
.reset {
  color: #fe4d45;
  border: 1px solid #fe4d45;
  background-color: #fff;
  &:hover {
    color: #fff;
    border: 1px solid #fe4d45;
    background-color: #fe4d45;
  }
}
.coupon-btn {
  display: flex;
  justify-content: end
}
.label-style {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 110px;
}
.link-tip {
  color: #f56c6c;
  margin-left: 120px;
  margin-top: 16px;
}
.req-style {
  color: #f56c6c;
}
</style>
